import Vue from 'vue'
import VueC3 from 'vue-c3'
import 'c3/c3.min.css'
Vue.component('VueC3', VueC3)
Vue.use(VueC3)
